import axios from 'axios'
import HTTP from './http'

export default {
    login: payload => axios.post(HTTP.LOGIN, payload),
    validToken: () => axios.get(HTTP.VALID_TOKEN),
    getUserRoles: () => axios.patch(HTTP.USER_ROLES),
    getInfo: payload => axios.get(HTTP.USER_ROLES, { params: { user_id: payload } }),
    setFreeSubAsPurchased: payload => axios.put(HTTP.PAYMENT_INFO, { ...payload }),
    sendPlusSubSms: payload => axios.post(HTTP.SEND_PLUS_SUB_SMS, { payload }),
    validateCouponCode: params => axios.get(HTTP.VALIDATE_COUPON_CODE, { params }),
    checkDuplicatePayment: payload => axios.get(HTTP.CHECK_DUPLICATE_PAYMENT, { params: { ...payload } }),
    createSubscriptionRegistry: payload => axios.post(HTTP.USER_SUBSCRIPTION, { ...payload }),
    createCollectiveSubscription: payload => axios.post(HTTP.COLLECTIVE_SUBSCRIPTION, { ...payload })
}
